export const CompetitorsType = [
    { label: 'Primary', value: 'primary' },
    { label: 'Secondary', value: 'secondary' },
]